module.exports = __webpack_public_path__ + "static/media/website_app_icon_new.5a38eae9.svg";